import { HeaderActionButton } from "frontend/app-header/header-action-button/header-action-button";
import { SaveInLibraryIcon } from "frontend/app-header/left-header/menu/icons";
import { MenuLabel } from "frontend/ui-components/dropdown-menu/label/label";
import { PreferencesMenu } from "frontend/app-header/left-header/menu/preferences-menu";
import { useHeaderContext } from "frontend/context/header-context";
import { Menu, MenuItem } from "frontend/ui-components/dropdown-menu/dropdown-menu";
import styles from "./left-header.module.css";
import { useIsCIMReorderEnabled } from "utils/url-utils";
import { PlanFeatureName } from "shared/datamodel/schemas";
import usePlanFeatureValue from "frontend/hooks/use-plan-features";
import useCheckoutFlow from "frontend/billing/use-checkout-flow";
import { CrownV2 } from "frontend/icons/crown-v2";

const Trigger = () => {
  return (
    <HeaderActionButton className={styles.undoRedoIcon}>
      <svg xmlns="http://www.w3.org/2000/svg" width="11" height="12" fill="none" viewBox="0 0 11 12">
        <path
          stroke="#1E1E1E"
          strokeLinecap="round"
          strokeWidth="1.2"
          d="M.8 1.2h8.88M.8 6.24h8.88M.8 11.28h8.88"
        ></path>
      </svg>
    </HeaderActionButton>
  );
};

const TemplateMenu = () => {
  const { setCreatingTemplate } = useHeaderContext();
  const isCIMReorderEnabled = useIsCIMReorderEnabled();
  const isCreateTemplateEnabled = usePlanFeatureValue(PlanFeatureName.CREATE_TEMPLATE_ENABLED);
  const [_, setShowUpgradeModal] = useCheckoutFlow();

  const handleSaveAsTemplate = () => {
    if (isCreateTemplateEnabled) {
      setCreatingTemplate();
    } else {
      setShowUpgradeModal({ name: "create-template", value: "" });
    }
  };

  if (isCIMReorderEnabled) {
    return (
      <MenuItem
        label={
          <MenuLabel
            icon={<SaveInLibraryIcon />}
            label={
              <div className={styles.labelContent}>
                <span>Save as template</span>
                {!isCreateTemplateEnabled && <CrownV2 />}
              </div>
            }
            tooltip="Create a template in your library"
          />
        }
        onClick={handleSaveAsTemplate}
        className={styles.cimTemplateMenuItem}
      />
    );
  }

  return (
    <Menu label={<MenuLabel icon={<SaveInLibraryIcon />} label="Save as template" />}>
      <MenuItem
        label={
          <MenuLabel
            icon={<SaveInLibraryIcon />}
            label={
              <div className={styles.labelContent}>
                <span>Save in library</span>
                {!isCreateTemplateEnabled && <CrownV2 />}
              </div>
            }
            tooltip="Create a template in your library"
          />
        }
        onClick={handleSaveAsTemplate}
      />
      {/* TODO: Add save as link */}
      {/* <MenuItem
        label={
          <MenuLabel
            icon={<SaveAsLinkIcon />}
            label="Save as a link"
            tooltip={
              <div>
                Create a template link to your canvas.
                <br /> Anyone with the link can use this canvas as a template
              </div>
            }
          />
        }
      /> */}
    </Menu>
  );
};

export const LeftHeaderMenu = () => {
  return (
    <Menu label={<Trigger />} className={styles.menu}>
      <TemplateMenu />
      <PreferencesMenu />
    </Menu>
  );
};
